import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box} from 'views/components';
import {
  WbSunnyOutlined,
  CheckCircleOutlined,
  PersonOutlineOutlined,
  QueryStatsOutlined,
  CasesOutlined,
  DescriptionOutlined,
  ChatOutlined,
  AutorenewOutlined,
} from 'views/icons';

import NavbarService from './NavbarService';

import featureFlags from 'utils/feature_flags/feature_flags';

import {useLocation} from 'react-router-dom';

const NavbarServices = (props) => {
  const {
    account,
  } = props;

  const location = useLocation();

  return (
    <Box
      sx={{
        mb: 1,
        ml: 1,
      }}
    >
      <Box>
        <NavbarService
          currentPath={location.pathname}
          options={[
            {
              title: 'navbar.NavOptions.MyDay',
              link: '/tasks/my-day',
              icon: <WbSunnyOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
            },
            {
              title: 'navbar.NavOptions.AllTasks',
              link: '/tasks/all-tasks',
              icon: <CheckCircleOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
            },
          ]}
        />
      </Box>
      <Box>
        <NavbarService
          title={'navbar.NavHeaders.Records'}
          currentPath={location.pathname}
          options={[
            ...(account === 'care' ? [
              {
                title: 'navbar.NavOptions.ClientLead.Options.List',
                link: '/client_lead',
                icon: <PersonOutlineOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
              },
            ] : []),
            ...(account === 'recruiter' ? [
              {title: 'navbar.NavOptions.Caregiver.Options.List', link: '/caregiver'},
              {title: 'navbar.NavOptions.Career.Options.List', link: '/career'},
            ] : []),
            ...(account === 'ops' ? [
              {title: 'navbar.NavOptions.Client.Options.List', link: '/client'},
              {title: 'navbar.NavOptions.Caregiver.Options.List', link: '/caregiver'},
              {title: 'navbar.NavOptions.Schedule.Options.Client', link: '/schedule/client'},
              {title: 'navbar.NavOptions.Schedule.Options.Caregiver', link: '/schedule/caregiver'},
            ] : []),
          ]}
        />
      </Box>
      {
        account === 'care' &&
          <Box>
            <NavbarService
              title={'navbar.NavHeaders.Metrics'}
              currentPath={location.pathname}
              options={[
                {
                  title: 'navbar.NavOptions.Metrics.Options.LeadFunnel',
                  link: '/metrics/lead-funnel',
                  icon: <QueryStatsOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
                },
                ...(featureFlags.oversightMarkingReadsEnabled ? [
                  {
                    title: 'navbar.NavOptions.Metrics.Options.AgentReportCard',
                    link: '/metrics/agent-report-card',
                    icon: <QueryStatsOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
                  },
                ] : []),
              ]}
            />
          </Box>
      }
      <Box>
        <NavbarService
          title={'navbar.NavHeaders.System'}
          currentPath={location.pathname}
          options={[
            {
              title: 'navbar.NavOptions.Playbooks',
              link: '/playbooks',
              icon: (
                <Box
                  component='img'
                  src='/icons/playbook.svg'
                  sx={{
                    width: 16,
                    height: 16,
                  }}
                />
              ),
            },
            {
              title: 'navbar.NavOptions.Skills',
              link: '/skills',
              icon: (
                <Box
                  component='img'
                  src='/icons/skill.svg'
                  sx={{
                    width: 16,
                    height: 16,
                  }}
                />
              ),
            },
            {
              title: 'navbar.NavOptions.Automations',
              link: '/automations',
              icon: (
                <Box
                  component='img'
                  src='/icons/automation.svg'
                  sx={{
                    width: 16,
                    height: 16,
                  }}
                />
              ),
            },
            {
              title: 'navbar.NavOptions.Cases',
              link: '/cases',
              icon: <CasesOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
            },
            {
              title: 'navbar.NavOptions.DomainGuides',
              link: '/domain-guides',
              icon: <DescriptionOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
            },
            {
              title: 'navbar.NavOptions.Agent.Options.Chat',
              link: '/agent/chat',
              icon: <ChatOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
            },
            {
              title: 'navbar.NavOptions.Agent.Options.Routines',
              link: '/agent/routines',
              icon: <AutorenewOutlined sx={{fontSize: 16, color: '#A8A49E'}} />,
            },
          ]}
        />
      </Box>
    </Box>
  );
};
NavbarServices.propTypes = {
  account: PropTypes.oneOf(['care', 'recruiter', 'ops']).isRequired,
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NavbarServices));
